import Quill, { Delta } from 'quill';
import { cloneDeep } from 'lodash';

export const createQuillEditor = ({
  editor,
  toolbarId,
  readOnly = false,
  placeholder = '',
}): Quill => {

  return new Quill(editor, {
    placeholder,
    modules: {
      toolbar: `#${toolbarId}`,
      table: false,
      history: {
        userOnly: true
      },
      preserveFormatOnEnter: true,
    },
    theme: 'snow',
    readOnly,
  });
}



/**
 * Enables applying current format to embeds at insertion time. Specifically handles formula embeds 
 * to preserve formatting. 
 * Warning: this is a hack and may break in future versions of Quill.
 * @param {Quill} quillInstance - The Quill editor instance to modify
 */

export const enableFormattingEmbeds = (quillInstance: Quill) => {
  quillInstance.editor.insertEmbed = function (index, embed, value) {
    if (embed === 'formula') {
      const currentFormats = this.getFormat(index);
      
      this.scroll.insertAt(index, embed, value);
      Object.keys(currentFormats).forEach((format) => {
        this.scroll.formatAt(index, 1, format, currentFormats[format]);
      });
      return this.update(
        new Delta().retain(index).insert({ [embed]: value }, cloneDeep(currentFormats)),
      );

    }
    else {
      // Default behavior
      this.scroll.insertAt(index, embed, value);
      return this.update(new Delta().retain(index).insert({ [embed]: value }));  
    }

  }
}


const trimDelta = (originalDelta: Delta): Delta => {
  const delta = new Delta(originalDelta.ops);

  // Helper to check if an op is an empty insert
  const isEmptyInsert = (op: any) =>
      typeof op.insert === 'string' && op.insert.trim() === '';

  // Trim leading empty inserts
  while (delta.ops.length && isEmptyInsert(delta.ops[0])) {
    delta.ops.shift();
  }

  // Trim trailing empty inserts
  while (delta.ops.length && isEmptyInsert(delta.ops[delta.ops.length - 1])) {
    delta.ops.pop();
  }

  return delta;
};

export const deltaHasText = (delta: Delta): boolean => delta ? trimDelta(delta).length() > 0 : false;
